/* global $ */
class SwapContentsBlock {
  constructor($el, manager) {
    this.manager = manager;
    this.$el = $el;
    this.isFadein = false;
    this.mediaQuery       = window.matchMedia('(max-width: 800px)');
    this.windowHeight = 0;
    this.elHeight = 0;
  }
  fadein() {
    this.windowHeight = window.innerHeight;

    if(!this.manager.animationSection.isTouchDevice) {
      this.elHeight = this.$el.height();
    }

    this.isFadein = true;
    this.$el.css('display', 'block');

    // if(!this.manager.animationSection.isTouchDevice) {
      this.titleTimeout = setTimeout(() => {
        this.$el.find('.ProductFeature__title').addClass('-start');
      }, 100);
      this.descTimeout = setTimeout(() => {
        this.$el.find('.ProductFeature__description').addClass('-start');
      }, 300);
      /*
      this.chartTimeout = setTimeout(() => {
        this.$el.find('.DataChart').addClass('-fadein');
      }, 800);
      */
    // }


  }
  fadeout() {
    this.isFadein = false;
    clearTimeout(this.titleTimeout);
    clearTimeout(this.descTimeout);
    clearTimeout(this.chartTimeout);

    // if(!this.manager.animationSection.isTouchDevice) {
      this.$el.find('.ProductFeature__title').removeClass('-start');
      this.$el.find('.ProductFeature__description').removeClass('-start');
      // this.$el.find('.DataChart').removeClass('-fadein');
    // }



    if(!this.manager.animationSection.isTouchDevice) {
      this.$el.css('display', 'none');
    }


  }

  update(value) {
    if(!this.manager.animationSection.isTouchDevice) {
      if(this.mediaQuery.matches) {
        let top = this.windowHeight - (this.elHeight + this.windowHeight) * value;
        this.$el.css('transform', `translate3d(0, ${top}px, 0)`);
      }
    }

  }
}

class SwapContents {
  constructor(animationSection) {
    this.animationSection = animationSection;
    this.$container = $('.SwapContents');
    this.blocks = [];
    this.isFadein = false;
    this.pastTarget = -1;
    this.isStartAction = false;
    this.isShow = false;

    $('.SwapContentsBlock').each((i, e) => {
      this.blocks.push(new SwapContentsBlock($(e), this));
    });
  }
  start() {
    this.isStartAction = true;
  }
  fadein() {
    if(!this.isFadein) {
      if(this.pastTarget != -1) {
        this.change(this.pastTarget);
      }
      this.isFadein = true;
      this.$container.stop(false).css({'opacity':0, 'display':'block'}).animate({'opacity': 1}, 400, 'easeOutExpo');
    } else {
      if(!this.isShow) {
        this.isShow = true;
        for(let i = 0; i < this.blocks.length; i++) {
          if(i == this.pastTarget) {
            this.blocks[i].fadein();
          } else {
            this.blocks[i].fadeout();
          }
        }
      }
    }
  }
  fadeout() {
    if(this.isFadein) {
      this.isFadein = false;
      this.$container.stop(false).animate({'opacity':0}, 400, 'easeOutSine', () => {
        this.$container.css('display', 'none');

        for(let i = 0; i < this.blocks.length; i++) {
          this.blocks[i].fadeout();
        }
      });
    }
  }
  change(target) {
    this.pastTarget = target;
    if(this.isStartAction) {
      for(let i = 0; i < this.blocks.length; i++) {
        if(i == target) {
          this.blocks[i].fadein();
        } else {
          this.blocks[i].fadeout();
        }
        this.isShow = true;
      }
    }
  }
  checkState() {
    /*
    if(target == 'pc') {
      for(let i = 0; i < this.blocks.length; i++) {
        if(this.blocks[i].isFadein) {
          this.blocks[i].fadein();
        } else {
          this.blocks[i].fadeout();
        }
      }
    } else if(target == 'sp') {
      for(let i = 0; i < this.blocks.length; i++) {
        this.blocks[i].fadein();
      }
    }
    */
  }
}

export default SwapContents;
